import { render, staticRenderFns } from "./inputModule.vue?vue&type=template&id=ec54cdde&scoped=true&"
import script from "./inputModule.vue?vue&type=script&lang=js&"
export * from "./inputModule.vue?vue&type=script&lang=js&"
import style0 from "./inputModule.vue?vue&type=style&index=0&id=ec54cdde&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec54cdde",
  null
  
)

export default component.exports